import React, { useState } from 'react';
import { TextField, Button, Box, Grid, Select, InputLabel, MenuItem } from '@material-ui/core';
import { format } from "../commons/utils";
import { FormControl } from '@material-ui/core';

import useStyles from './useStyles'
import { ErrorMessage } from "@hookform/error-message";
import { singleInputValidator } from '../commons/utils';

const PasoDosForm = ({ pais, setPais, region, setRegion, ciudad, setCiudad, comuna, setComuna ,telefono, setTelefono, correo, setCorreo,  errors, setError, nombrePais, nombreRegion, nombreComuna, tipoCalle, setTipoCalle, direccion, setDireccion, nCalle, setNCalle, departamento, setDepartamento }) => {


    const classes = useStyles();

  
      const handleChangePais = (event) => {
        setPais(event.target.value);
      };
      const handleChangeRegion = (event) => {
        setRegion(event.target.value);
      };
      const handleChangeComuna = (event) => {
        setComuna(event.target.value);
      };

      const handleChangeCiudad = (event) => {
        setCiudad(event.target.value);
      };
      const handleChangeDpto = (event) => {
        setDepartamento(event.target.value);
      };

      const handleChangeTelefono = event => {
        setTelefono(event.target.value)
      }
      
      const handleChangeCorreo = event => {
        setCorreo(event.target.value)
      }
      
      const handleChangeDireccion = event => {
        setDireccion(event.target.value)
      }

      const handleChangeTipoCalle = event => {
        setTipoCalle(event.target.value)
      }
      const handleChangeNCalle = event => {
        setNCalle(event.target.value)
      }
    
      

   
    const [subTitulo, setSubTitulo] = useState('Información de contacto') 

    const printPais = () => {
      return nombrePais.map((item,index)=>{
        return <MenuItem  key={index} value={item.codigo}>{item.nombre}</MenuItem>
      })
    }
  
    const printRegion = () => {
      return nombreRegion.map((item,index)=>{
        return <MenuItem  key={index} value={item.region_id}>{item.region_nombre}</MenuItem>
      })
    }

 
    const printComuna = () => {
      return nombreComuna.map((item,index)=>{
       // console.log("item", item)
        return <MenuItem  key={index} value={item.comuna_id}>{item.comuna_nombre}</MenuItem>
      })
    }
    return (


    <>
        {/* aca va el sub titulo del formulario */}
        <Box display="flex" justifyContent="start">
          <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', marginLeft: 45 }}>{subTitulo}</h3>
        </Box>
        {/* cuerpo para inputs, puede ser mas de un grid dependiendo de las filas que se necesite */}
        <Grid>

          <FormControl className={classes.formControlComponent}  size="small">
          <InputLabel id="paislabel" variant="outlined" >País</InputLabel>
                <Select
                required
                labelId="paislabel"
                id="paislabel"
                variant="outlined"
                value={pais}
                label="País"
                onChange={handleChangePais}
                name="pais"
                >
                   {printPais()}
                </Select>
                <ErrorMessage
                  style={{ color: 'red' }}
                  name="pais"
                  as="div"
                  errors={errors}
                />
          </FormControl>

          <FormControl className={classes.formControlComponent}  size="small">
            <InputLabel id="regionlabel"  variant="outlined" >Región</InputLabel>
                <Select
                required
                labelId="regionlabel"
                id="regionlabel"
                variant="outlined"
                value={region}
                label="Región"
                onChange={handleChangeRegion}
          
                name="region"
                >
                {printRegion()}
                </Select>
                <ErrorMessage
                  style={{ color: 'red' }}
                  name="region"
                  as="div"
                  errors={errors}
                />
          </FormControl>


          <FormControl className={classes.formControlComponent}  size="small">
          <InputLabel id="selectlabelComuna"  variant="outlined" >Comuna</InputLabel>
                <Select
                required
                labelId="comunalabel"
                id="selectlabelComuna"
                variant="outlined"
                value={comuna}
                label="Comuna"
                onChange={handleChangeComuna}
              
                name="comuna"
                >
                     {printComuna()}
                </Select>
                <ErrorMessage
                  style={{ color: 'red' }}
                  name="comuna"
                  as="div"
                  errors={errors}
                />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
              <TextField onChange={handleChangeTelefono} onBlur={() => {
                setTelefono(telefono.trim())
                singleInputValidator(telefono,"telefono",setError, [])
              }} value={telefono} name="telefono" id="input-id" variant="outlined" type="number"  label="Telefono" size="small" />
              <ErrorMessage
                style={{ color: 'red' }}
                name="telefono"
                as="div"
                errors={errors}
              />
        </FormControl>

        <FormControl className={classes.formControlComponent}  size="small">
          <InputLabel id="selectlabel" variant="outlined" >Tipo de Calle</InputLabel>
                <Select
                labelId="tipocallelabel"
                id="tipocalleselect"
                variant="outlined"
                value={tipoCalle}
                name="tipoCalle"
                label="Tipo de Calle"
                onChange={handleChangeTipoCalle}
                >
                    <MenuItem value={0}>Seleccione</MenuItem>
                    <MenuItem value={1}>Avda</MenuItem>
                    <MenuItem value={2}>Calle</MenuItem>
                    <MenuItem value={3}>Pje</MenuItem>
                </Select>
        </FormControl>


        <FormControl className={classes.formControlComponent}>
          <TextField onChange={handleChangeDireccion} onBlur={() => {
            setDireccion(direccion.trim())
            singleInputValidator(direccion,"direccion",setError, [])
          }} value={direccion} name="direccion" id="input-id" variant="outlined" label="Dirección" size="small" />
          <ErrorMessage
            style={{ color: 'red' }}
            name="direccion"
            as="div"
            errors={errors}
          />
        </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField onChange={handleChangeNCalle} onBlur={() => {
              
              singleInputValidator(nCalle,"nCalle",setError, [])
            }} value={nCalle} name="nCalle" id="input-id" variant="outlined" label="Numero Calle" size="small" />
            <ErrorMessage
              style={{ color: 'red' }}
              name="nCalle"
              as="div"
              errors={errors}
            />
        </FormControl>



        <FormControl className={classes.formControlComponent}  size="small">
          <InputLabel id="selectlabel" variant="outlined" >Departamento</InputLabel>
                <Select
                labelId="departamentolabel"
                id="departamentoselect"
                variant="outlined"
                value={departamento}
                name="departamento"
                label="Departamento"
                onChange={handleChangeDpto}
                >
                    <MenuItem value={0}>Seleccione</MenuItem>
                    <MenuItem value={1}>Block</MenuItem>
                    <MenuItem value={2}>Casa</MenuItem>
                    <MenuItem value={3}>Depto.</MenuItem>
                </Select>
        </FormControl>





        <FormControl className={classes.formControlComponent}>
          <TextField onChange={handleChangeCorreo} onBlur={() => {
            setCorreo(correo.trim())
            singleInputValidator(correo,"correo",setError, [{option:'eMail'}])
          }} value={correo} name="correo" id="input-id" variant="outlined" label="Correo" size="small" />
          <ErrorMessage
            style={{ color: 'red' }}
            name="correo"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent}>
        </FormControl>


        </Grid>

      </>



  )
}

export default PasoDosForm